module.exports = __webpack_public_path__ + "img/heir.036c7311.svg";